import * as qualityAssuranceApi from '../../api/qualityAssuranceApi'
import * as announcementApi from '../../api/announcementApi'

const state={
    qualityAssuranceQueryInput:{
        phoneNo:'',
        imeiNo:'',
        validateCode:''
    },
    qualityAssuranceQueryOutput:{
        
    },
    sendSmsInput:{

    },
    sendSmsOutput:{

    },
    validateSmsInput:{

    },
    validateSmsOutput:{

    }
}

const getters={

}

const actions ={
    async sendSms({commit},sendSmsInput){
        const response =await announcementApi.sendSms(sendSmsInput);
        commit('setSendSms',response)
    },
    async validateSms({commit},validateSmsInput){
        const response =await announcementApi.validateSms(validateSmsInput);
        commit('setValidateSms',response)
    },
    async testLoginout({commit},validateSmsInput){
        const response =await announcementApi.testLoginout(validateSmsInput);
    }
    // async queryQualityAssuranceQueryOutput({commit},announcementListInput){
    //     const response =await qualityAssuranceApi.getAnnouncementList(announcementListInput);
    //     commit('setAnnouncementList',response.data)
    // },
    // async getAnnouncementEntity({commit},announcementDetailInput){
    //     const response =await announcementApi.getAnnouncementEntity(announcementDetailInput);
    //     commit('setAnnouncementDetail',response.data)
    // }
}

const mutations ={
    setSendSms(state,data){
        //console.log(data);
        state.sendSmsOutput=data;
    },
    setValidateSms(state,data){
        state.validateSmsOutput=data;
        //console.log(data)
    },
    ClearInput(state){
        state.qualityAssuranceQueryInput={
            phoneNo:'',
            imeiNo:'',
            validateCode:''
        }
    }
    // setAnnouncementList(state,data){
    //     state.qualityAssuranceQueryOutput=data;
    // },
    // setAnnouncementDetail(state,data){
    //     state.announcementDetailOutput=data;
    // }
}

export default{
     namespaced:true,
     getters,
     state,
     actions,
     mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/qualityAssuranceQuery.js